// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../graphql/api/index';

import { gql } from 'graphql-tag';
export const ImageCommonFragmentDoc = gql`
    fragment imageCommon on Image {
  __typename
  id
  alt
}
    `;